import styled from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  .description_label,
  .description_value {
    text-transform: capitalize;
  }

  .component_ad_campaign_code_media {
    padding: 12px;
    border: 1px solid ${color.grey1};
    box-sizing: border-box;
    width: 216px;
    display: inline-flex;
    .ant-image {
      height: 192px;
      width: 192px;
      border-radius: 12px;
      overflow: hidden;
      .ant-image-img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }
    .component_ad_campaign_code_media_display {
      img,
      video {
        width: 192px;
        height: 192px;
        background-repeat: no-repeat;
        object-fit: cover;
        border-radius: 12px;
      }
    }
  }
`;

export default Wrapper;
